var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4430_10299)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.79517 1.79518C4.18864 -0.598359 8.08328 -0.59843 10.4768 1.79518C12.4433 3.76168 12.7937 6.74118 11.5289 9.06919L17.4914 15.0316C18.1695 15.7098 18.1695 16.8132 17.4914 17.4914C17.1523 17.8305 16.7069 18 16.2615 18C15.8161 18 15.3707 17.8304 15.0316 17.4914L9.06921 11.529C8.15799 12.024 7.14711 12.272 6.13601 12.272C4.56397 12.272 2.99195 11.6736 1.79517 10.4768C-0.598341 8.08327 -0.598341 4.18873 1.79517 1.79518ZM15.781 16.742C16.046 17.0069 16.477 17.0069 16.742 16.742C17.0069 16.477 17.0069 16.046 16.742 15.781L10.9306 9.96964C10.7902 10.1449 10.6392 10.3145 10.4768 10.4768C10.3144 10.6392 10.1449 10.7902 9.96959 10.9306L15.781 16.742ZM2.54459 9.72738C4.52487 11.7077 7.74712 11.7077 9.7274 9.72738C11.7077 7.74707 11.7077 4.52489 9.7274 2.54457C8.73726 1.55443 7.43658 1.05936 6.13601 1.05936C4.83541 1.05936 3.53473 1.55443 2.54459 2.54457C0.564344 4.52493 0.564344 7.7471 2.54459 9.72738Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.40417 3.37265C4.12554 2.65124 5.08471 2.25391 6.10491 2.25391C7.12514 2.25391 8.08431 2.65121 8.80571 3.37265C9.01268 3.57961 9.01268 3.91511 8.80571 4.12207C8.59878 4.32907 8.26325 4.329 8.05629 4.12207C7.53506 3.60085 6.84206 3.31376 6.10487 3.31376C5.36775 3.31376 4.67475 3.60085 4.15352 4.12207C4.05006 4.22557 3.91442 4.27732 3.77883 4.27732C3.64323 4.27732 3.50756 4.22557 3.40413 4.12207C3.19724 3.91514 3.19724 3.57961 3.40417 3.37265Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4430_10299"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "matrix(-1 0 0 1 18 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.2e7e2e654a37af3be31f04b4fdc0502e.svg";
export { ForwardRef as ReactComponent };